export default __webpack_public_path__ + "static/media/15exigo.ebf6dac9.jpg";